(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire04f6"];
var parcelRegister = parcelRequire.register;
parcelRegister("4GJKx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $369e92947825c2b5$export$71511d61b312f219; });
function $369e92947825c2b5$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("1wc17", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $11b219ef186b1c94$export$71511d61b312f219; });
function $11b219ef186b1c94$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $11b219ef186b1c94$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $11b219ef186b1c94$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $11b219ef186b1c94$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("cYr9j", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $972025e4d4e45634$export$71511d61b312f219; });

var $b8Rim = parcelRequire("b8Rim");

var $9yjJS = parcelRequire("9yjJS");

var $3U0IP = parcelRequire("3U0IP");
function $972025e4d4e45634$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $b8Rim._)(derived);
    return (0, $3U0IP._)(_this, (0, $9yjJS._)() ? Reflect.construct(derived, args || [], (0, $b8Rim._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("b8Rim", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $81c9c858187986cb$export$71511d61b312f219; });
function $81c9c858187986cb$export$71511d61b312f219(o) {
    $81c9c858187986cb$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $81c9c858187986cb$export$71511d61b312f219(o);
}

});

parcelRegister("9yjJS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6f4699ca644cfb51$export$71511d61b312f219; });
function $6f4699ca644cfb51$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($6f4699ca644cfb51$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("3U0IP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2d772972bd4fe337$export$71511d61b312f219; });

var $d3H5E = parcelRequire("d3H5E");

var $l0HdX = parcelRequire("l0HdX");
function $2d772972bd4fe337$export$71511d61b312f219(self, call) {
    if (call && ((0, $l0HdX._)(call) === "object" || typeof call === "function")) return call;
    return (0, $d3H5E._)(self);
}

});
parcelRegister("d3H5E", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $981cfaf5c821609e$export$71511d61b312f219; });
function $981cfaf5c821609e$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("dcsZi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $99c2e1b2c4a01e52$export$71511d61b312f219; });

var $koVwh = parcelRequire("koVwh");
function $99c2e1b2c4a01e52$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $koVwh._)(subClass, superClass);
}

});
parcelRegister("koVwh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $eda2aabf2c4b7bd6$export$71511d61b312f219; });
function $eda2aabf2c4b7bd6$export$71511d61b312f219(o, p) {
    $eda2aabf2c4b7bd6$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $eda2aabf2c4b7bd6$export$71511d61b312f219(o, p);
}

});


})();
//# sourceMappingURL=notification.aec957b6.js.map
